import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot } from "vue"

import { onMounted, watch } from "vue";
import { useField } from "vee-validate";


export default /*#__PURE__*/_defineComponent({
  __name: 'validation-provider',
  props: {
  value: { type: [Array, String, Number, Object], required: true },
  rules: { type: Object },
  name: { type: String, required: true },
  setOnMounted: { type: Boolean, default: false },
},
  setup(__props) {

const props = __props;

const { errorMessage, setValue } = useField(props.name, props.rules);

watch(
  () => props.value,
  () => {
    setValue(props.value);
  },
  { deep: true }
);

onMounted(() => {
  if (props.setOnMounted) {
    setValue(props.value);
  }
});

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    errorMessage: _unref(errorMessage),
    setValue: _unref(setValue)
  })
}
}

})